module.exports = __webpack_public_path__ + "img/plaid_shirt.790540d3.jpg";